import React, { useEffect } from 'react';
import ManufaturingBanner from './ManufaturingBanner';

import Automotivemobilitecards from './Automotivemobilitecards';
import AutomobilityTabs from './AutomobilityTabs';
import Automobilityverticaltabs from './Automobilityverticaltabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import DigitalmobilityTabscards from './DigitalmobilityTabscards';
import Ditalcards from './Ditalcards';
import Digitalcapabilityhovercards from './Digitalcapabilityhovercards';

import ManufacturingPafeData from './ManufacturingPafeData';
import ManufacturingVeritcalTabs from './ManufacturingVeritcalTabs';
import ManufacturingHoveredards from './ManufacturingHoveredards';
import AerospaceInsightsCards from './AerospaceInsightsCards';
import Footer from './Footer';
import CrigotManufacturiingPage from './CrigotManufacturiingPage';
import Itrequestform from './Itrequestform';
import Manufacturingsecondtabs from './Manufacturingsecondtabs';
import Manufacturingcrigotmobile from './Manufacturingcrigotmobile';
import Manufacturingthirdtab from './Manufacturingthirdtab';
const ManufacturingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>
      <ManufaturingBanner />

      <ManufacturingPafeData />
      <ManufacturingVeritcalTabs />
      <Manufacturingsecondtabs />
      <Manufacturingthirdtab />
      {/* <ManufacturingHoveredards /> */}

      <CrigotManufacturiingPage />

      <div className='mobile-crigot'>
        <Manufacturingcrigotmobile />
      </div>
      {/* <BankingVerticalTabs  /> */}
      {/* <Healthverticalcards /> */}
      {/* <Bankinghoveredcards /> */}
      {/* <Healthcarecards  /> */}
      {/* <AerospaceInsightsCards /> */}
      <br></br>
      <Itrequestform />
      <div style={{ marginTop: "-60px" }}>
        <Footer />
      </div>

      {/* <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default ManufacturingPage;